export default {
  SAVE_SECURITY_MARK: 'saveSecurityMark',
  DELETE_SECURITY_MARK: 'deleteSecurityMark',
}
